export default __webpack_public_path__ + "static/1-485d12bc09b6f604501940a113e50bf9.jpg";